module.exports = __webpack_public_path__ + "static/media/mclaren_logo.aaa64e82.svg";